module.exports = __webpack_public_path__ + "img/dark-footer-1.289034de.png";